module.exports = __webpack_public_path__ + "img/PD1505109752882003968.072453fb.png";